import { array, struct } from 'io-ts/Decoder';

import { Id as FranchiseId } from '../../../franchise/Id';

export const Request = struct({
	franchiseIds: array(FranchiseId),
});
